<template>
  <svg width="36" height="44" xmlns="http://www.w3.org/2000/svg"><path d="M5.122.5l28.925 18.93a3 3 0 0 1 0 5.021L5.122 43.381a3 3 0 0 1-4.643-2.51V3.012A3 3 0 0 1 5.122.5z" :fill="fill" fill-rule="evenodd"/></svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: 'white'
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/icons/icon-play.vue